import React from 'react';
import { Layout, theme } from 'antd';

const { Content } = Layout;

interface ContentComponentProps {
  children: React.ReactNode;
}

const ContentComponent: React.FC<ContentComponentProps> = ({ children }) => {
  const {
    token: { borderRadiusLG },
  } = theme.useToken();

  return (
    <Content style={{ margin: '0', overflow: 'initial' }}>
      <div
        style={{
          padding: 24,
          background: 'transparent',
          borderRadius: borderRadiusLG,
          minHeight: 'calc(100vh - 200px)',
        }}
      >
        {children}
      </div>
    </Content>
  );
};

export default ContentComponent;
